import ComingSoon from "@/components/custom/coming-soon";
const TransactionPage = () => <ComingSoon label="Transactions" />;
export default TransactionPage;